
const LOCAL_STORAGE_LANGUAGE = "lang";


export  {Texts, LOCAL_STORAGE_LANGUAGE};

class Texts {

    lang = "fa";

    constructor(props: { lang: "fa"|"en" }) {
        this.lang = props.lang;
    }

    t(name: string, ...params: any[]){
        let t = this.texts[name][this.lang];
        params.forEach((val, index)=>{
            if(t.includes("{"+(index+1)+"}"))
                t = t.replace("{"+(index+1)+"}", val)
        });
        return t;
    }

    static instance(lang: "fa"|"en" ){
        return new Texts({lang: lang})
    }

    texts:any = {
        'login.button_phone_ph': {
            en: "Phone number",
            fa: "شماره موبایل"
        },
        'login.button_code_ph': {
            en: "Enter code",
            fa: "کد را وارد کنید"
        },
        'login.button_send_code': {
            en: "Send confirmation code",
            fa: "ارسال کد تأیید"
        },
        'login.button_confirm_code': {
            en: "Confirm code",
            fa: "تایید کد"
        },
        'login.button_back': {
            en: "Edit number",
            fa: "بازگشت (ویرایش شماره)"
        },
        'login.button_guest_login': {
            en: "Login as guest",
            fa: "ورود به صورت مهمان"
        },
        'icons.back': {
            en: "",
            fa: ""
        }
    }
}
